// src/views/components/CustomerTabs.js
import { NavLink, useParams } from "react-router-dom";

export default function CustomerTabs({ customer, className = "px-6 p-6" }) {
  const { id } = useParams();

  return (
    <div className={`border-b border-gray-200 bg-white ${className}`}>
      {/* ชื่อร้าน */}
      <h2 className="text-2xl font-bold text-gray-800 mb-2">
        {customer?.AR_Name} {customer?.AR_LastName || ""} {customer?.AR_Code || ""}
      </h2>

      {/* Tabs */}
      <nav className="flex gap-8">
        <NavLink
          to={`/EditCustomer/${id}`}
          className={({ isActive }) =>
            `pb-2 ${
              isActive
                ? "border-b-2 border-red-500 font-bold text-black"
                : "text-gray-500 hover:text-red-500"
            }`
          }
        >
          ข้อมูลลูกค้า
        </NavLink>

        {/* <NavLink
          to={`/history/${id}`}
          className={({ isActive }) =>
            `pb-2 ${
              isActive
                ? "border-b-2 border-red-500 font-bold text-black"
                : "text-gray-500 hover:text-red-500"
            }`
          }
        >
          ผลการนัดหมาย
        </NavLink> */}

        <NavLink
          to={`/quotelist/${id}`}
          className={({ isActive }) =>
            `pb-2 ${
              isActive
                ? "border-b-2 border-red-500 font-bold text-black"
                : "text-gray-500 hover:text-red-500"
            }`
          }
        >
          ใบเสนอราคา
        </NavLink>

        <NavLink
          to={`/contractlist/${id}`}
          className={({ isActive }) =>
            `pb-2 ${
              isActive
                ? "border-b-2 border-red-500 font-bold text-black"
                : "text-gray-500 hover:text-red-500"
            }`
          }
        >
          สัญญา
        </NavLink>
        
      </nav>
    </div>
  );
}
